import { message } from "antd"
import sponsoredProductsApi from "../../../api-wrapper/sponsoredProducts/sponsoredProductsApi"
import campaignsHelper from "../../../helper/campaigns.helper"
import { IChangedTarget } from "../../../types/target"
import { options } from "../types/campaignActions"
import { campaignStates, stateByCampaignId } from "../../../types/customers"
import { changeCampaignStatus } from "../../../api-wrapper/campaigns/spCampaignApi"
import { setStateType } from "../../../types/setStateType"
import { ICampaignDataColumns } from "../types/table"
import { Key } from "react"

function unmanageCampaigns(
  selectedRowCampaignIds: Key[],
  setCampaigns: setStateType<ICampaignDataColumns[]>,
  setSelectedRowCampaignIds: setStateType<Key[]>
) {
  if (selectedRowCampaignIds.length === 0) {
    message.error("No campaign selected")
    return
  }

  campaignsHelper
    .unmanageSponsoredProductCampaigns(selectedRowCampaignIds)
    .then((status) => {
      message.success("Unmanage success")

      setCampaigns((prevCampaigns) => {
        return prevCampaigns.filter(
          (prevCampaign) => !selectedRowCampaignIds.includes(prevCampaign.campaignId)
        )
      })
      setSelectedRowCampaignIds([])
    })
    .catch((err) => {
      message.error("Unmanage error")
    })
}

function applyBestCPC(
  setCampaigns: setStateType<ICampaignDataColumns[]>,
  selectedTargetRowCampaignIds: Key[]
) {
  if (selectedTargetRowCampaignIds.length === 0) {
    message.error("No target selected")
    return
  }

  setCampaigns((prevCampaigns) =>
    prevCampaigns.map((prevCampaign) => {
      const isSelectedTarget = prevCampaign.targets.some((target) =>
        selectedTargetRowCampaignIds.includes(target.targetId)
      )
      if (!isSelectedTarget) {
        return prevCampaign
      }

      const targets = prevCampaign.targets.map((target) => {
        if (selectedTargetRowCampaignIds.includes(target.targetId)) {
          return {
            ...target,
            userDefinedLimitedCPC: target.bestCPC,
          }
        }

        return {
          ...target,
        }
      })

      return {
        ...prevCampaign,
        targets,
      }
    })
  )
}

export function changeStateCampaign(
  state: campaignStates,
  setCampaigns: setStateType<ICampaignDataColumns[]>,
  selectedRowCampaignIds: Key[]
) {
  if (selectedRowCampaignIds.length === 0) {
    message.error("No campaign selected")
    return
  }

  const stateByCmapaignId: stateByCampaignId[] = selectedRowCampaignIds.map((campaignId) => {
    return {
      campaignId: Number(campaignId),
      state,
    }
  })

  changeCampaignStatus({ stateByCampaignIds: stateByCmapaignId })
    .then((res) => {
      setCampaigns((prevCampaigns) =>
        prevCampaigns.map((prevCampaign) => {
          if (selectedRowCampaignIds.includes(prevCampaign.campaignId)) {
            return {
              ...prevCampaign,
              campaignStatus: state,
            }
          }

          return prevCampaign
        })
      )
      message.success("Change status success")
    })
    .catch((err) => {
      message.error("Change status error")
    })
}

interface HandleMenuClickParams {
  event: {
    key: string
  }
  selectedRowCampaignIds: Key[]
  setSelectedRowCampaignIds: setStateType<Key[]>
  selectedTargetRowCampaignIds: Key[]
  setCampaigns: setStateType<any>
  campaigns: ICampaignDataColumns[]
  setIsOpen: setStateType<boolean>
}

export const handleMenuClick = (params: HandleMenuClickParams) => {
  const {
    event,
    setCampaigns,
    selectedRowCampaignIds,
    setSelectedRowCampaignIds,
    selectedTargetRowCampaignIds,
    setIsOpen,
  } = params

  switch (event.key) {
    case options.PAUSE:
      changeStateCampaign(campaignStates.PAUSED, setCampaigns, selectedRowCampaignIds)
      break
    case options.ENABLE:
      changeStateCampaign(campaignStates.ENABLED, setCampaigns, selectedRowCampaignIds)
      break
    case options.UNMANAGE:
      unmanageCampaigns(selectedRowCampaignIds, setCampaigns, setSelectedRowCampaignIds)
      break
    case options.APPLY_BEST_CPC:
      applyBestCPC(setCampaigns, selectedTargetRowCampaignIds)
      break
    case options.ADD_TO_PROJECT:
      setIsOpen(true)
      break
  }
}

export function applyOnAmazon(
  campaigns: ICampaignDataColumns[],
  selectedTargetRowCampaignIds: Key[]
) {
  if (selectedTargetRowCampaignIds.length === 0) {
    message.error("No target selected")
    return
  }

  const targetChanges: IChangedTarget[] = []

  campaigns.forEach((campaign) => {
    const targets: IChangedTarget[] = []
    campaign.targets.forEach((target) => {
      const newBid = target.userDefinedLimitedCPC ?? target.limitedCPC
      if (!selectedTargetRowCampaignIds.includes(target.targetId) || !Number.isFinite(newBid)) {
        return
      }

      targets.push({
        targetId: String(target.targetId),
        newBid: newBid as number,
        oldBid: target.limitedCPC ?? 0,
        targetType: target.targetType,
      })
    })

    targetChanges.push(...targets)
  })

  sponsoredProductsApi
    .applyOnAmazon({
      cangedTargets: targetChanges,
    })
    .then((res) => {
      message.success("Applied on Amazon successfully")
    })
    .catch((e) => {
      message.error("Failed to apply on Amazon")
    })
}
